import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { logout } from '../redux/reducers/userSlice';
import { useDispatch } from 'react-redux';
import { useToast } from '@chakra-ui/react';

export const useIdle = ({ onIdle, idleTime = 1 }) => { // idleTime in minutes
  const [isIdle, setIsIdle] = React.useState(false);
  const [timedOut, setTimedOut] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const dispatch = useDispatch();
  const toast = useToast();

  const handleOnIdle = () => {
      setIsIdle(true);
      setShowModal(true);
      setTimedOut(true);
      onIdle();
      dispatch(logout);

   
  };

   

  const { getRemainingTime, getLastActiveTime, reset } = useIdleTimer({
    timeout: 1000 * 60 * idleTime, // Convert minutes to milliseconds
    onIdle: handleOnIdle,
    debounce: 500,
  });

  const handleUserActivity = () => {
    if (timedOut) {
      setTimedOut(false);
      setIsIdle(false);
      setShowModal(false);
      reset();
    }
    reset();
  };

  React.useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, handleUserActivity));
    return () => {
      events.forEach(event => window.removeEventListener(event, handleUserActivity));
    };
  }, [timedOut, reset]);

  return {
    getRemainingTime,
    getLastActiveTime,
    isIdle,
  };
};






// import React from "react";
// import { useIdleTimer } from "react-idle-timer";


// export const useIdle = ({ onIdle, idleTime = 1 }) => {
//   const [isIdle, setIsIdle] = React.useState();
//   const [timedOut, setTimeout] = React.useState();
//   const [showModal, setShowModal] = React.useState(false);
  

//   const handleOnIdle = (event) => {
    
//     if (timedOut) {
//       onIdle();
//       setShowModal(false);
//     } else {
//       setTimeout(()=>{ setIsIdle(true);
//         setTimeout(true);
//        // console.log("user is idle", event);
//         setShowModal(true);
//       //  console.log("Last Active", getLastActiveTime());
//         }, 20000)
//         reset()
//     }

//     console.log('idletimer>>', idleTime);

//     // onIdle();
//   };
 
//   const { getRemainingTime, getLastActiveTime, reset } = useIdleTimer({
//     timeout: 1000 * 60 * idleTime,
//     onIdle: handleOnIdle,
//     debounce: 500,
//   });

//   return {
//     getRemainingTime,
//     getLastActiveTime,
//     isIdle,
//   };
// };
